import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';

const SiteOfficeHeader = () => {
  return (
    <CardHeader className="text-center pb-4 sm:pb-6 relative overflow-hidden bg-[#062a4a]">
      {/* Dot pattern + ambient glows (match login branding panel) */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, #fff 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        />
        <div className="absolute -top-[30%] -right-[10%] w-[400px] h-[400px] rounded-full bg-[#0ea5e9]/30 blur-3xl" />
        <div className="absolute -bottom-[40%] -left-[10%] w-[400px] h-[400px] rounded-full bg-[#0c2f52]/80 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 space-y-3 sm:space-y-4 py-3 sm:py-4">
        {/* Logo and Title */}
        <div className="flex flex-col items-center justify-center space-y-3 sm:space-y-4">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-2xl flex items-center justify-center shadow-xl p-2.5 sm:p-3">
            <img
              src="/lovable-uploads/cf50c7b9-f54c-4913-8d24-f05cb973ea81.png"
              alt="PT. Gemilang Cipta Wawasan"
              className="w-full h-full object-contain"
            />
          </div>

          <div className="text-center space-y-1.5">
            <CardTitle
              className="text-2xl sm:text-3xl font-extrabold tracking-tight text-white"
              style={{ fontFamily: "'Sora', system-ui, sans-serif" }}
            >
              PT. Gemilang Cipta Wawasan <span className="text-[#0ea5e9]">.</span>
            </CardTitle>
            <p className="text-[#e0f2fe]/90 text-sm sm:text-base font-medium">
              Pilih Site Office Anda
            </p>
          </div>
        </div>

        {/* Description */}
        <p className="text-[#e0f2fe]/70 text-xs sm:text-sm max-w-xl mx-auto leading-relaxed">
          Selamat datang di sistem manajemen proyek konstruksi. Pilih site office untuk melanjutkan.
        </p>
      </div>
    </CardHeader>
  );
};

export default SiteOfficeHeader;
